import React, { useContext } from 'react'
import { CommandCenterStateProviderContext } from '../context';

const useSatellite = () => {
    const context = useContext(CommandCenterStateProviderContext);
    if (context === undefined) {
        throw new Error('useSatellite must be used within a Satellite Provider');
    }
    const { satellites, selected_satellite, set_selected_satellite, satellite_groups, set_satellite_groups, selected_satellite_group, set_selected_satellite_group } = context;

    return { satellites, selected_satellite, set_selected_satellite, satellite_groups, set_satellite_groups, selected_satellite_group, set_selected_satellite_group }
}

export default useSatellite